import useGlobalAppEffect from '~/src/hooks/useGlobalAppEffect'

const GlobalEffects = () => {
  useGlobalAppEffect()

  return null
}

export default GlobalEffects
